import { useAppDispatch, useAppSelector } from '@src/core/hooks';
import {
  sendResetPasswordCode,
  validateResetPasswordCode,
  changePassword as changePasswordThunk,
  setResendEmail,
  confirmEmailResend,
  confirmEmailFix,
  resetPasswordSelector,
  passwordRecoveryEmailSelector,
  passwordRecoveryCodeSelector,
} from '@src/features/customers/auth/store/auth';
import { canResendCode } from '@src/domains/customers';
import useCountdownTimer from '@src/hooks/useCountdownTimer';

export function usePasswordRecovery() {
  const dispatch = useAppDispatch();
  const { loading, isCodeValid, requestLockedUntil } = useAppSelector(resetPasswordSelector);
  const recoveryEmail = useAppSelector(passwordRecoveryEmailSelector);
  const recoveryCode = useAppSelector(passwordRecoveryCodeSelector);

  const { minutes, seconds } = useCountdownTimer(requestLockedUntil ? new Date(requestLockedUntil) : new Date());
  const canResend = canResendCode(requestLockedUntil);

  const sendResetCode = (email: string) => dispatch(sendResetPasswordCode({ email }));
  const validateCode = (email: string, code: string) =>
    dispatch(validateResetPasswordCode({ email, code }, { trackEvents: true }));
  const changePassword = (email: string, code: string, password: string) =>
    dispatch(changePasswordThunk({ email, code, password }, { trackEvents: true, markModified: true }));
  const openResendPrompt = () => dispatch(setResendEmail(true));
  const confirmResendCode = () => dispatch(confirmEmailResend());
  const confirmEmailChange = () => dispatch(confirmEmailFix());

  return {
    sendResetCode,
    validateCode,
    changePassword,
    openResendPrompt,
    confirmResendCode,
    confirmEmailChange,
    loading,
    recoveryEmail,
    recoveryCode,
    isCodeValid,
    requestLockedUntil,
    resend: { minutes, seconds, canResend },
  };
}
